import { useCallback } from 'react'
import { usePaymentFlow } from 'modules/payment'


const usePurchaseInOneClickButton = (paymentMethodId: string) => {
  const { submit, isProcessing } = usePaymentFlow()

  const submitPurchaseInOneClick = useCallback(() => {
    return submit({ paymentMethodId })
  }, [ submit, paymentMethodId ])

  return {
    submitPurchaseInOneClick,
    isProcessing,
  }
}


export default usePurchaseInOneClickButton
